import React from 'react';
import { useTranslation } from 'next-i18next';

import { IAnalyst } from '../../../api/investorApi';

import InvestorBlock from '../InvestorBlock';
import Table from '../../../components/Table';

interface IProps {
  title: string;
  anchor: string;
  data: IAnalyst[];
}

function AnalystCoverage(props: IProps) {
  const { title, anchor, data } = props;
  const { t } = useTranslation('investor');
  const titleCoop = t('coop');
  const titleEmail = t('email');
  const titleAnalyst = t('analyst');
  const titleDisclaim = t('titleDisclaim');
  const contentStockDisclaim = t('contentStockDisclaim');
  const contentSortExplain = t('contentSortExplain');

  return (
    <InvestorBlock title={title} anchor={anchor}>
      <div className="w-full overflow-x-auto">
        <Table
          columns={[
            {
              title: titleCoop,
              dataIndex: 'coop',
              key: 'coop',
              width: '40%',
            },
            {
              title: titleAnalyst,
              dataIndex: 'name',
              key: 'name',
              width: '40%',
            },
            {
              title: titleEmail,
              dataIndex: 'email',
              key: 'email',
              width: '40%',
            },
          ]}
          dataSource={data as any}
        />
      </div>
      <div className="mt-[12px]">
        <p className="mb-[12px]	 align-middle text-sm text-[#95989e]">{contentSortExplain}</p>
        <div className="text-[#111925] opacity-60">
          <p className="mb-[9px] text-sm font-medium">{titleDisclaim}</p>
          <p className="text-xs">{contentStockDisclaim}</p>
        </div>
      </div>
    </InvestorBlock>
  );
}

export { AnalystCoverage };
